export default Vue => {
  Vue.component("v-inbox-wrapper", () => import("./v-inbox-wrapper.vue"));
};
